import { LOCATION_TYPES } from '@shared/core/appointment-types'
import { LOCATION_OPTION_COPY, meetUnavailableText } from 'src/modules/user/utils/appointment-type-form'
import type { LocationSelectOption } from '../location-select'

export type BuildLocationOptionsInput = {
  isMeetBlocked: boolean
  calendarName: string
}

export function buildLocationOptions({
  isMeetBlocked,
  calendarName,
}: BuildLocationOptionsInput): LocationSelectOption[] {
  return LOCATION_TYPES.map((value) => {
    const { label, description } = LOCATION_OPTION_COPY[value]
    const disabled = value === 'google_meet' && isMeetBlocked
    return { value, label, description: disabled ? meetUnavailableText(calendarName) : description, disabled }
  })
}
